import * as THREE from "three";
import { Context } from "../core/context";

import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  DrawCuttingSymbolHandleAcceptParams,
  DrawCuttingSymbolHandleReturnData,
} from "@/core/Parameters";

class DrawFSCuttingSymbolModify implements IModifyOperation {
  private m_context: Context;
  private m_orthogonality: boolean;
  private m_locationObject: THREE.Line;
  private m_auxLine: THREE.Line | undefined;
  private m_returnData!: DrawCuttingSymbolHandleReturnData;
  private m_TextLabel: ULabel;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_points: THREE.Vector3[] = [];
  private m_scale: number = 1;
  private m_tempObjectGroup: THREE.Group = new THREE.Group();
  private m_cuttingTempObjectGroup: THREE.Group = new THREE.Group();
  private m_cuttingFirstOrEndTempObjectGroup: THREE.Group = new THREE.Group();
  private m_currentHandlerCuttingTempObject: THREE.LineSegments | undefined;
  private m_isSelectDir: boolean = false;

  constructor(context: Context, params: DrawCuttingSymbolHandleAcceptParams) {
    this.m_context = context;
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_context.SceneManager.AuxModel.add(this.m_tempObjectGroup);
    this.m_tempObjectGroup.add(this.m_cuttingTempObjectGroup);
    this.m_tempObjectGroup.add(this.m_cuttingFirstOrEndTempObjectGroup);
    this.m_orthogonality = params.orthogonality;
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point.clone();
    this.m_locationObject.position.copy(point.point.clone());
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 35;
    TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
    if (this.m_points.length == 0) {
      this.m_TextLabel.SetVaule(
        "请点取第一个剖切点,按Esc键将退出操作",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    } else if (this.m_points.length >= 1) {
      if (this.m_orthogonality) {
        let p = point.point.clone();
        this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
          p,
          this.m_points[0]
        );
      }
      if (this.m_points.length == 1) {
        this.m_TextLabel.SetVaule(
          "请点取下一个剖切点,按Esc键将退出操作",
          TextLabelLocation,
          new THREE.Vector3(1, 0, 0)
        );

        this.updateFirstAndCurCuttingTempObject();
      } else if (this.m_points.length == 2) {
        this.m_TextLabel.SetVaule(
          "请选择方向,按空格键将完成操作,按Esc键将退出操作",
          TextLabelLocation,
          new THREE.Vector3(1, 0, 0)
        );
      }

      this.m_auxLine?.geometry.setFromPoints([
        this.m_points[0],
        this.m_curPoint,
      ]);
      this.m_auxLine?.computeLineDistances();
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    if (this.m_isSelectDir) {
      return;
    }
    if (this.m_points.length == 0) {
      this.m_auxLine = this.m_context.ToolsManager.CreatedAuxLine();
      this.m_points.push(point.point.clone());
    } else if (this.m_points.length == 1) {
      if (this.m_orthogonality) {
        this.m_points.push(this.m_curPoint.clone());
      } else {
        this.m_points.push(point.point.clone());
      }
    }
    if (this.m_points.length == 1) {
      this.createCuttingFirstOrEndTempObject();
      this.createCuttingFirstOrEndTempObject();
    } else if (this.m_points.length == 2) {
      this.m_isSelectDir = true;
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (e.code == "Space") {
      if (this.m_points.length >= 2) {
        if (this.m_isSelectDir) {
          this.startDirSelect();
          this.m_context.ModifyManager.ModifyFinish(
            ModifyOperateState.complete
          );
        }
      }
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.m_returnData = {
      points: this.m_points,
      dirPoint: this.m_curPoint,
    };
    this.clear();
    if (operate == ModifyOperateState.complete) {
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private createCuttingFirstOrEndTempObject() {
    let geo = new THREE.BufferGeometry();
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let line = new THREE.LineSegments(geo, mat);
    line.frustumCulled = false;
    this.m_cuttingFirstOrEndTempObjectGroup.add(line);
  }
  private updateFirstAndCurCuttingTempObject() {
    let firstCuttingTempObject = this.m_cuttingFirstOrEndTempObjectGroup
      .children[0] as THREE.LineSegments;
    let endCuttingTempObject = this.m_cuttingFirstOrEndTempObjectGroup
      .children[1] as THREE.LineSegments;

    let fSCuttingTempFirstPoints = [
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(1, 0, 0),
    ];
    let fSCuttingTempEndPoints = [
      new THREE.Vector3(-1, 0, 0),
      new THREE.Vector3(0, 0, 0),
    ];

    let xAxis = new THREE.Vector3(1, 0, 0);
    let zAxis = new THREE.Vector3(0, 0, 1);

    let s = new THREE.Vector3(1, 1, 1);
    let q = new THREE.Quaternion();

    let v = new THREE.Vector3()
      .subVectors(this.m_curPoint.clone(), this.m_points[0])
      .normalize();
    let angle = v.angleTo(xAxis);
    if (v.clone().cross(xAxis).z > 0) {
      angle = -angle;
    }
    q.setFromAxisAngle(zAxis, angle);
    firstCuttingTempObject.geometry.setFromPoints([
      ...fSCuttingTempFirstPoints,
    ]);
    endCuttingTempObject.geometry.setFromPoints([...fSCuttingTempEndPoints]);

    let firstMatrix = new THREE.Matrix4().compose(this.m_points[0], q, s);
    let endMatrix = new THREE.Matrix4().compose(this.m_curPoint, q, s);
    firstCuttingTempObject!.geometry.applyMatrix4(firstMatrix);
    endCuttingTempObject!.geometry.applyMatrix4(endMatrix);
    // firstCuttingTempObject.geometry.setFromPoints([...firstPoints]);
    // endCuttingTempObject.geometry.setFromPoints([...EndPoints]);

    // let endVector = new THREE.Vector3()
    //   .subVectors(endCuttingTempObjectPoint1, endCuttingTempObjectPoint2)
    //   .normalize();
    // let curVector = new THREE.Vector3()
    //   .subVectors(this.m_curPoint, endCuttingTempObjectPoint2)
    //   .normalize();
    // if (curVector.clone().cross(endVector).z < 0) {
    //   firstPoints[0] = new THREE.Vector3(0, 0.6, 0);
    // } else {
    //   EndPoints[0] = new THREE.Vector3(0, 0.6, 0);
    // }
    // firstCuttingTempObject.geometry.setFromPoints([...firstPoints]);
    // endCuttingTempObject.geometry.setFromPoints([...EndPoints]);
    // firstCuttingTempObject!.geometry.applyMatrix4(this.m_firstMatrix);
    // endCuttingTempObject!.geometry.applyMatrix4(this.m_endMatrix);
  }

  private startDirSelect() {
    this.m_currentHandlerCuttingTempObject?.removeFromParent();
    let xAxis = new THREE.Vector3(1, 0, 0);
    let zAxis = new THREE.Vector3(0, 0, 1);
    let endCuttingTempObject = this.m_cuttingFirstOrEndTempObjectGroup
      .children[1] as THREE.LineSegments;
    let EndPoints = [
      new THREE.Vector3(0, -0.6, 0),
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(-1, 0, 0),
    ];
    let endP = this.m_points[this.m_points.length - 1];
    let endMatrix = new THREE.Matrix4();
    let q = new THREE.Quaternion();
    let s = new THREE.Vector3(1, 1, 1);
    let v = new THREE.Vector3()
      .subVectors(endP, this.m_points[this.m_points.length - 2])
      .normalize();
    let angle = v.angleTo(xAxis);
    if (v.clone().cross(xAxis).z > 0) {
      angle = -angle;
    }
    q.setFromAxisAngle(zAxis, angle);
    endMatrix.compose(endP, q, s);
    endCuttingTempObject.geometry.setFromPoints([...EndPoints]);
    endCuttingTempObject!.geometry.applyMatrix4(endMatrix);
  }
  private clear() {
    this.m_context.ToolsManager.GroupClear(this.m_tempObjectGroup);
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_auxLine!,
    ]);
    this.m_TextLabel?.dispose();
  }
}

export { DrawFSCuttingSymbolModify };
